import { FileFormat } from "../utils/downloadFile";

export interface IBusinessFile {
  /** Base64 bytes; only sent by a backend that predates `downloadUrl`. */
  file?: string;
  /** Short-lived presigned S3 link; absent when signing that row failed. */
  downloadUrl?: string;
  expiresInSeconds?: number;
  fileName: string;
  fileExtension: FileFormat;
  type: BusinessFileType;
  /** Set on person-owned rows, so an annotation lands on the right person. */
  personId?: string;
  /**
   * S3 coordinates of the bytes, matched against a row's `file`. `fileName` above
   * is a display name and is rewritten for person identity sides, so it cannot
   * carry the join.
   */
  sourceBucketName?: string;
  sourceFileName?: string;
}

/** Mirrors BusinessAdditionalFileTypes in the backend's shared/types/business.interface.ts. */
export enum BusinessFileType {
  COMPANY_INFO_FILE = "COMPANY_INFO",
  TMA_FILE = "TMA_FILE",
  TMA_METADATA_FILE = "TMA_METADATA_FILE",
  BANK_CONFIRMATION_FILE = "BANK_CONFIRMATION_FILE",
  UNDERLYING_COMPANY_DOCUMENT_FILE = "UNDERLYING_COMPANY_DOCUMENT_FILE",
  UBO_DOCUMENT_FILE = "UBO_DOCUMENT_FILE",
  IDV_DOCUMENT_FILE = "IDV_DOCUMENT_FILE",
  COMPRESSED_ATTACHMENTS = "COMPRESSED_ATTACHMENTS",
  PERSON_IDENTITY_FRONT_FILE = "PERSON_IDENTITY_FRONT_FILE",
  PERSON_IDENTITY_BACK_FILE = "PERSON_IDENTITY_BACK_FILE",
}
